import React from 'react';
import { useTranslation } from 'react-i18next';

export const TechnicalDocumentation: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="card" style={{ flex: 1, minHeight: 0, height: '100%' }}>
      <object
        data={`${process.env.PUBLIC_URL}/SoilFerApp_UserGuide.pdf`}
        type="application/pdf"
        width="100%"
        height="100%"
      >
        <p>
          <a href={`${process.env.PUBLIC_URL}/SoilFerApp_UserGuide.pdf`}>
            {t('docs.downloadGuide')}
          </a>
        </p>
      </object>
    </div>
  );
};
